export default __webpack_public_path__ + "static/media/ForceDecompImg.a0571e00.jpg";